import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import { useSelector as rawUseSelector, TypedUseSelectorHook, useDispatch as rawUseDispatch } from 'react-redux'
import { persistReducer, persistStore } from 'redux-persist'
import sessionStorage from 'redux-persist/lib/storage/session'
import sampleReducer from 'slicers/sampleSlice'
import PageReducer from 'slicers/PageSlice'
import LoginReducer from 'slicers/LoginSlice'
import SearchJuryoReducer from 'slicers/SearchSlicers/SearchJuryoSlice'
import SearchUserReducer from 'slicers/SearchSlicers/SearchUserSlice'
import SearchLogReducer from 'slicers/SearchSlicers/SearchLogSlice'
import TableReducer from 'slicers/TableSlicers/TableSlice'
import TableJuryoReducer from 'slicers/TableSlicers/TableJuryoSlice'
import TableUserReducer from 'slicers/TableSlicers/TableUserSlice'
import TableLogReducer from 'slicers/TableSlicers/TableLogSlice'
import ModalReducer from 'slicers/ModalSlice'
import ModalUserReducer from 'slicers/ModalUserSlice'
import ModalFileReducer from 'slicers/ModalFileSlice'

const persistConfig = {
  key: 'root',
  storage: sessionStorage,
}

const authPersistConfig = {
  key: 'auth',
  storage: sessionStorage,
}

const reducers = combineReducers({
  sample: persistReducer(persistConfig, sampleReducer),
  PageReducer: PageReducer,
  LoginReducer: persistReducer(authPersistConfig, LoginReducer),
  SearchJuryoReducer: SearchJuryoReducer,
  SearchUserReducer: SearchUserReducer,
  TableReducer: TableReducer,
  TableJuryoReducer: TableJuryoReducer,
  TableUserReducer: TableUserReducer,
  SearchLogReducer: SearchLogReducer,
  TableLogReducer: TableLogReducer,
  ModalReducer: ModalReducer,
  ModalUserReducer: ModalUserReducer,
  ModalFileReducer: ModalFileReducer,
})

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export const persistor = persistStore(store)
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export const useSelector: TypedUseSelectorHook<RootState> = rawUseSelector
export const useDispatch = rawUseDispatch
